module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/477.cb390270.png";